import styled from 'styled-components';
import { baseContainer } from '@redsift/design-system';
import { StyledDialogContentActionsProps } from './types';

/**
 * Component style.
 */
export const StyledDialogContentActions = styled.div<StyledDialogContentActionsProps>`
  display: flex;
  ${baseContainer}

  margin-top: 8px;
  margin-bottom: 8px;

  &:focus-visible {
    outline: none;
  }
`;
